define('widgets/questPath/viewmodel',[
    'underscore',
    'knockout'
], function(_, ko) {

    var QuestPath = function() {
        var self = this;
        self.pathObjectives = {};

        self.isCompleted = function(data, index) {
            return ko.deferredComputed(function() {
                var currentObjectiveIndex = self.quest.getCurrentObjectiveIndex();
                return data.objective.isVisiblyCompleted(index, currentObjectiveIndex)();
            });
        };
    };

    QuestPath.prototype.activate = function(settings) {
        this.quest = settings.quest;
        this.pathObjectives = this.quest.path;
        this.isSmall = settings.small;
    };

    return QuestPath;
});
